import React from 'react';
import { FormGroup } from 'react-bootstrap';
import CommonAction from './CommonAction';
import { NewCheckbox } from '../../../../../Components/PIM/common/NewCheckbox';

export function CheckBox({
  name,
  options,
  label,
  disable,
  requiredField,
  error,
  fromForm,
  duplicatingItem,
  pageIndex,
  gridIndex,
  onChange,
  editingInput,
  showDelete,
  deleteItem,
  supplierVisible,
  handleSupplierPermission,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  return (
    <FormGroup className="flex-fill position-relative">
      <div>
        <p className={`asterisk-req mb-1 fs-custom-module ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>
          {label}
          {requiredField && <span>*</span>}
        </p>
        {options?.map((opt, opIndex) => {
          return (
            <div className="checkbox-label my-1" key={`${opt?.uniqueKey}`}>
              <NewCheckbox id={`${opt?.name}_${opIndex}_${gridIndex}_${pageIndex}`} name={name} disabled={disable} checked={opt?.value} onChange={(e) => onChange(e.target.checked, opt?.name, gridIndex, pageIndex)} />
              <label htmlFor={`${opt?.name}_${opIndex}_${gridIndex}_${pageIndex}`} className="chklabel">
                <span>{opt?.name}</span>
              </label>
              {fromForm && onElement && (
                <CommonAction
                  editingInput={editingInput}
                  gridIndex={gridIndex}
                  pageIndex={pageIndex}
                  showDelete={showDelete}
                  deleteItem={deleteItem}
                  handleDuplicateItem={handleDuplicateItem}
                  supplierVisible={supplierVisible}
                  handleSupplierPermission={handleSupplierPermission}
                  handleStaticGrid={handleStaticGrid}
                  isStatic={isStatic}
                />
              )}
            </div>
          );
        })}
        {error?.status && <span className="error-message">{error.errorMsg}</span>}
      </div>
    </FormGroup>
  );
}
export default CheckBox;
